import { WidgetParameters } from 'interfaces/WidgetParameters';
import { Action } from 'redux';
import { objectMerge } from 'utils/objects';

import {
    InitParametersAction,
    ParameterActionType,
    SetCmsUrlAction,
    SetWebviewAdapterAction,
    UpdateParametersAction,
} from './parameters.actions';

const initialState: WidgetParameters = {};

export const parametersReducer = (state = initialState, action: Action<ParameterActionType>) => {
    switch (action.type) {
        case ParameterActionType.Init: {
            const parameters = (action as InitParametersAction).payload;
            return { ...parameters };
        }
        case ParameterActionType.Update: {
            const parameters = (action as UpdateParametersAction).payload;
            return objectMerge(state, parameters);
        }
        case ParameterActionType.SetWebviewAdapter: {
            const webViewAdapter = (action as SetWebviewAdapterAction).payload;
            return {
                ...state,
                webViewAdapter,
            };
        }
        case ParameterActionType.SetCmsUrl: {
            const cmsUrl = (action as SetCmsUrlAction).payload;
            return {
                ...state,
                cmsUrl,
            };
        }
        default:
            return state;
    }
};
